function submissionFor(submissions, judgeName) {
  const key = judgeName.replace(/[\.\#\$\/\[\]]/g, "_");
  return submissions[key]
    || Object.values(submissions).find((submission) => submission.judgeName === judgeName)
    || null;
}

function cardTotals(submission) {
  const rounds = submission?.rounds || [];
  const rawRed = rounds.reduce((sum, round) => sum + (round.red || 0), 0);
  const rawBlue = rounds.reduce((sum, round) => sum + (round.blue || 0), 0);
  return {
    red: typeof submission?.totalRed === "number"
      ? submission.totalRed
      : rawRed + (submission?.boutWinner === "red" ? 1 : 0),
    blue: typeof submission?.totalBlue === "number"
      ? submission.totalBlue
      : rawBlue + (submission?.boutWinner === "blue" ? 1 : 0),
  };
}

// `onReopen(judgeName)`, when passed (RefBout), adds a per-judge "Reopen card" control.
export default function JudgeScoreBreakdown({ judges = [], submissions = {}, fighterRed, fighterBlue, onReopen, reopeningJudge }) {
  return (
    <div className="bg-dark-800 rounded-lg p-3 mb-3">
      <div className="text-xs font-bold text-gray-400 tracking-wider mb-2">JUDGE SCORE BREAKDOWN</div>
      <div className="grid grid-cols-[minmax(0,1fr)_auto_auto_auto] gap-x-2 px-2 pb-1 text-[10px] font-bold uppercase tracking-wide text-gray-600">
        <span>Judge</span>
        <span className="max-w-20 truncate text-right" style={{ color: "#EF9A9A" }}>{fighterRed}</span>
        <span />
        <span className="max-w-20 truncate" style={{ color: "#64B5F6" }}>{fighterBlue}</span>
      </div>
      {judges.map((judgeName) => {
        const submission = submissionFor(submissions, judgeName);
        const rounds = [...(submission?.rounds || [])].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
        const totals = cardTotals(submission);
        const bonusFighter = submission?.boutWinner === "red"
          ? fighterRed
          : submission?.boutWinner === "blue"
            ? fighterBlue
            : null;

        return (
          <div key={judgeName} className="py-2 border-t border-dark-500/50">
            <div className="grid grid-cols-[minmax(0,1fr)_auto_auto_auto] items-center gap-x-2 px-2">
              <span className="text-sm font-semibold text-gray-300 truncate">
                {judgeName}
                {onReopen && submission?.complete && (
                  <button type="button" onClick={() => onReopen(judgeName)} disabled={reopeningJudge === judgeName}
                    aria-label={`Reopen ${judgeName}'s card for correction`}
                    className="ml-2 px-1.5 py-0.5 bg-transparent border border-dark-500 rounded text-[10px] font-bold text-gray-400 cursor-pointer hover:text-yellow-400 hover:border-yellow-600 disabled:opacity-40">
                    {reopeningJudge === judgeName ? "Reopening..." : "↺ Reopen card"}
                  </button>
                )}
              </span>
              {submission ? (
                <>
                  <span className="font-display text-lg font-extrabold text-right" style={{ color: "#E53935" }}>{totals.red}</span>
                  <span className="text-gray-700 text-xs">&ndash;</span>
                  <span className="font-display text-lg font-extrabold" style={{ color: "#1E88E5" }}>{totals.blue}</span>
                </>
              ) : (
                <span className="col-span-3 text-xs text-gray-600">No score submitted</span>
              )}
            </div>
            {rounds.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-1 px-2">
                {rounds.map((round, position) => (
                  <span key={round.index ?? position} className="px-1.5 py-0.5 bg-dark-900 rounded text-[10px] text-gray-500">
                    R{(round.index ?? position) + 1}: <span style={{ color: "#EF9A9A" }}>{round.red || 0}</span>
                    <span className="text-gray-700">&ndash;</span>
                    <span style={{ color: "#64B5F6" }}>{round.blue || 0}</span>
                  </span>
                ))}
              </div>
            )}
            {bonusFighter && (
              <div className="mt-1 px-2 text-[10px] font-bold text-yellow-600">
                Includes +1 technical bonus to {bonusFighter}
              </div>
            )}
            {submission?.confirmedDraw && (
              <div className="mt-1 px-2 text-[10px] font-bold text-gray-500">Judge confirmed a draw; no bonus awarded</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
